/* Publish by EComposer at 2026-07-22 06:42:45*/
;try{
 (function initStarfield() {
  var canvas = document.getElementById('starfield');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var stars = [];

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    stars = [];
    var count = Math.floor((canvas.width * canvas.height) / 14000);
    for (var i = 0; i < count; i++) {
      stars.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.6 + 0.4,
        opacity: Math.random() * 0.45 + 0.15,
        speed: Math.random() * 0.18 + 0.03,
        twinkle: Math.random() * Math.PI * 2,
        gold: Math.random() > 0.4
      });
    }
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    stars.forEach(function (s) {
      s.twinkle += 0.015;
      var op = s.opacity * (0.5 + 0.5 * Math.sin(s.twinkle));
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = s.gold
        ? 'rgba(201, 169, 110, ' + op + ')'
        : 'rgba(184, 132, 155, ' + op + ')';
      ctx.fill();
      s.y += s.speed;
      if (s.y > canvas.height) { s.y = 0; s.x = Math.random() * canvas.width; }
    });
    requestAnimationFrame(animate);
  }

  resize();
  window.addEventListener('resize', resize);
  animate();
})();

// ----- ICONES SVG PAR THEME (or sur fond clair) -----
var THEME_SVG = {
  amour: '<svg viewBox="0 0 48 48" fill="none" stroke="#b8849b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M24 40 C 12 30, 5 22, 5 15 C 5 10, 9 6, 14 6 C 18 6, 22 9, 24 13 C 26 9, 30 6, 34 6 C 39 6, 43 10, 43 15 C 43 22, 36 30, 24 40 Z"/>'
    + '<circle cx="24" cy="15" r="1.5" fill="#b8849b"/>'
    + '<path d="M14 14 L18 18 M30 18 L34 14" opacity="0.6"/></svg>',
  sante: '<svg viewBox="0 0 48 48" fill="none" stroke="#7d9b8a" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M24 6 Q 36 10, 38 22 Q 40 34, 24 42 Q 8 34, 10 22 Q 12 10, 24 6 Z"/>'
    + '<path d="M24 10 L24 38" opacity="0.7"/>'
    + '<path d="M24 16 Q 18 18, 16 24 M24 22 Q 16 24, 14 30 M24 16 Q 30 18, 32 24 M24 22 Q 32 24, 34 30" opacity="0.7"/></svg>',
  maison: '<svg viewBox="0 0 48 48" fill="none" stroke="#c9a96e" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M6 24 L24 8 L42 24"/><path d="M10 22 L10 42 L38 42 L38 22"/>'
    + '<path d="M20 42 L20 30 L28 30 L28 42"/><circle cx="24" cy="18" r="1.5" fill="#c9a96e"/></svg>',
  travail: '<svg viewBox="0 0 48 48" fill="none" stroke="#6b4c8a" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M24 4 L44 24 L24 44 L4 24 Z"/><path d="M24 12 L36 24 L24 36 L12 24 Z"/>'
    + '<circle cx="24" cy="24" r="2.5" fill="#6b4c8a"/>'
    + '<path d="M24 4 L24 12 M24 36 L24 44 M4 24 L12 24 M36 24 L44 24" opacity="0.6"/></svg>',
  decisions: '<svg viewBox="0 0 48 48" fill="none" stroke="#c9a96e" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<circle cx="24" cy="24" r="19"/><circle cx="24" cy="24" r="14" opacity="0.5"/>'
    + '<path d="M24 8 L27 24 L24 27 L21 24 Z" fill="#c9a96e"/>'
    + '<path d="M24 40 L21 24 L24 21 L27 24 Z" opacity="0.6"/>'
    + '<circle cx="24" cy="24" r="2" fill="#c9a96e"/></svg>',
  spiritualite: '<svg viewBox="0 0 48 48" fill="none" stroke="#6b4c8a" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M24 4 L28 18 L42 20 L32 30 L34 44 L24 36 L14 44 L16 30 L6 20 L20 18 Z"/>'
    + '<circle cx="24" cy="24" r="3"/><circle cx="24" cy="24" r="1" fill="#6b4c8a"/></svg>'
};

// ----- DONNEES DES 30 QUESTIONS -----
var QUESTIONS = [
  { theme: 'amour', themeLabel: '\uD83D\uDC96 Amour & Relations',
    text: "Cette personne est-elle sinc\u00e8rement align\u00e9e avec mon chemin de vie en ce moment pr\u00e9sent ?",
    tip: "Formulation id\u00e9ale pour \u00e9valuer la justesse d'une relation naissante sans projection." },
  { theme: 'amour', themeLabel: '\uD83D\uDC96 Amour & Relations',
    text: "Y a-t-il une r\u00e9sonance \u00e9nerg\u00e9tique authentique entre [pr\u00e9nom] et moi aujourd'hui ?",
    tip: "Remplacez [pr\u00e9nom] par le nom de la personne. Tenez mentalement son image pendant la question." },
  { theme: 'amour', themeLabel: '\uD83D\uDC96 Amour & Relations',
    text: "Est-il b\u00e9n\u00e9fique pour mon \u00e9volution int\u00e9rieure que je poursuive cette relation ?",
    tip: "Cette formulation \u00e9vite le pi\u00e8ge du souhait inconscient en recentrant sur votre propre chemin." },
  { theme: 'amour', themeLabel: '\uD83D\uDC96 Amour & Relations',
    text: "Y a-t-il un blocage \u00e9motionnel h\u00e9rit\u00e9 \u00e0 lib\u00e9rer dans cette relation ?",
    tip: "Parfaite pour identifier les sch\u00e9mas r\u00e9p\u00e9titifs li\u00e9s \u00e0 la lign\u00e9e familiale ou aux vies pass\u00e9es." },
  { theme: 'amour', themeLabel: '\uD83D\uDC96 Amour & Relations',
    text: "Est-il temps pour moi de m'ouvrir \u00e0 une nouvelle rencontre amoureuse ?",
    tip: "Pose-la le matin au r\u00e9veil, dans un espace calme, apr\u00e8s trois respirations profondes." },

  { theme: 'sante', themeLabel: '\uD83C\uDF3F Sant\u00e9 & Bien-\u00eatre',
    text: "Cet aliment est-il b\u00e9n\u00e9fique pour mon corps \u00e0 ce moment pr\u00e9cis ?",
    tip: "Tenez l'aliment (ou sa photo) dans la main non-dominante pendant la formulation." },
  { theme: 'sante', themeLabel: '\uD83C\uDF3F Sant\u00e9 & Bien-\u00eatre',
    text: "Cette zone de mon corps n\u00e9cessite-t-elle une attention particuli\u00e8re aujourd'hui ?",
    tip: "Utilisez cette question en balayant votre corps du haut vers le bas, zone par zone." },
  { theme: 'sante', themeLabel: '\uD83C\uDF3F Sant\u00e9 & Bien-\u00eatre',
    text: "Ce compl\u00e9ment ou rem\u00e8de naturel est-il adapt\u00e9 \u00e0 mes besoins \u00e9nerg\u00e9tiques actuels ?",
    tip: "Jamais en remplacement d'un avis m\u00e9dical, toujours en compl\u00e9ment d'une consultation." },
  { theme: 'sante', themeLabel: '\uD83C\uDF3F Sant\u00e9 & Bien-\u00eatre',
    text: "Mon niveau d'\u00e9nergie vitale est-il suffisant pour entreprendre [action] aujourd'hui ?",
    tip: "Excellent pour ajuster votre emploi du temps selon vos vraies capacit\u00e9s du jour." },
  { theme: 'sante', themeLabel: '\uD83C\uDF3F Sant\u00e9 & Bien-\u00eatre',
    text: "Ce soin \u00e9nerg\u00e9tique ou cette pratique sera-t-il b\u00e9n\u00e9fique pour mon bien-\u00eatre global ?",
    tip: "Utilisez cette formulation pour choisir entre plusieurs approches th\u00e9rapeutiques." },

  { theme: 'maison', themeLabel: '\uD83C\uDFE0 Maison & Habitat',
    text: "Cette zone de ma chambre est-elle propice \u00e0 un sommeil profond et r\u00e9parateur ?",
    tip: "Marchez lentement en tenant la baguette. Une zone de sommeil doit produire un signal d'harmonie." },
  { theme: 'maison', themeLabel: '\uD83C\uDFE0 Maison & Habitat',
    text: "Existe-t-il un n\u0153ud g\u00e9opathog\u00e8ne ou une perturbation sous mon lit actuel ?",
    tip: "Un croisement brusque des baguettes confirme une zone \u00e0 \u00e9viter ou \u00e0 neutraliser." },
  { theme: 'maison', themeLabel: '\uD83C\uDFE0 Maison & Habitat',
    text: "Cette pi\u00e8ce b\u00e9n\u00e9ficierait-elle d'une purification \u00e9nerg\u00e9tique compl\u00e8te ?",
    tip: "Si oui, la sauge blanche, le palo santo ou l'encens oliban sont les meilleurs alli\u00e9s." },
  { theme: 'maison', themeLabel: '\uD83C\uDFE0 Maison & Habitat',
    text: "Cette plante ou cette d\u00e9coration harmonise-t-elle l'\u00e9nergie de ce lieu ?",
    tip: "Utile avant un achat important ou pour repositionner vos objets existants." },
  { theme: 'maison', themeLabel: '\uD83C\uDFE0 Maison & Habitat',
    text: "Ce logement est-il \u00e9nerg\u00e9tiquement favorable \u00e0 l'\u00e9quilibre de ma famille ?",
    tip: "Question fondamentale \u00e0 poser avant toute acquisition ou location significative." },

  { theme: 'travail', themeLabel: '\uD83D\uDCBC Travail & Finances',
    text: "Cette opportunit\u00e9 professionnelle est-elle align\u00e9e avec mon but de vie profond ?",
    tip: "Ancrez mentalement l'opportunit\u00e9 sp\u00e9cifique avant la formulation pour \u00e9viter la confusion." },
  { theme: 'travail', themeLabel: '\uD83D\uDCBC Travail & Finances',
    text: "Est-ce le moment \u00e9nerg\u00e9tiquement juste pour lancer ce projet ?",
    tip: "Si la r\u00e9ponse est non, reformulez en ajoutant \u00ab d'ici trois mois \u00bb pour affiner le timing." },
  { theme: 'travail', themeLabel: '\uD83D\uDCBC Travail & Finances',
    text: "Cette d\u00e9cision financi\u00e8re est-elle en r\u00e9sonance avec mon bien-\u00eatre \u00e0 long terme ?",
    tip: "\u00c9vite le pi\u00e8ge de l'attrait imm\u00e9diat en recentrant sur votre \u00e9quilibre global." },
  { theme: 'travail', themeLabel: '\uD83D\uDCBC Travail & Finances',
    text: "Ai-je besoin de lib\u00e9rer un blocage \u00e9nerg\u00e9tique autour de l'abondance ?",
    tip: "Si oui, envisagez un travail avec la citrine, la pyrite ou l'\u0153il de tigre." },
  { theme: 'travail', themeLabel: '\uD83D\uDCBC Travail & Finances',
    text: "Cette personne est-elle un partenaire professionnel b\u00e9n\u00e9fique pour moi ?",
    tip: "Visualisez la personne pendant la formulation. Une ouverture franche indique une collaboration saine." },

  { theme: 'decisions', themeLabel: '\uD83E\uDDED D\u00e9cisions & Choix',
    text: "Cette d\u00e9cision sert-elle v\u00e9ritablement mon \u00e9volution la plus haute ?",
    tip: "La formulation la plus puissante pour trancher un dilemme existentiel majeur." },
  { theme: 'decisions', themeLabel: '\uD83E\uDDED D\u00e9cisions & Choix',
    text: "Ai-je toutes les informations n\u00e9cessaires pour prendre ce choix sereinement ?",
    tip: "Si non, listez mentalement ce qui manque et reposez la question dans une semaine." },
  { theme: 'decisions', themeLabel: '\uD83E\uDDED D\u00e9cisions & Choix',
    text: "Mon intuition sur ce sujet est-elle fiable et non parasit\u00e9e par mes \u00e9motions ?",
    tip: "Question cruciale avant d'agir sur un ressenti fort. Calme d'abord, d\u00e9cidez ensuite." },
  { theme: 'decisions', themeLabel: '\uD83E\uDDED D\u00e9cisions & Choix',
    text: "Est-il pr\u00e9f\u00e9rable d'attendre avant d'agir sur [cette situation] ?",
    tip: "L'attente est parfois la d\u00e9cision la plus puissante. La baguette le confirme ou l'infirme." },
  { theme: 'decisions', themeLabel: '\uD83E\uDDED D\u00e9cisions & Choix',
    text: "Cette option A est-elle plus favorable que l'option B pour ma situation actuelle ?",
    tip: "Testez une paire d'options \u00e0 la fois. Jamais trois choix simultan\u00e9s." },

  { theme: 'spiritualite', themeLabel: '\u2728 Spiritualit\u00e9',
    text: "Cette pierre naturelle est-elle align\u00e9e avec mes besoins \u00e9nerg\u00e9tiques actuels ?",
    tip: "Posez la pierre devant vous ou tenez-la dans la main non-dominante pendant la question." },
  { theme: 'spiritualite', themeLabel: '\u2728 Spiritualit\u00e9',
    text: "Mon chakra [racine / sacr\u00e9 / solaire / c\u0153ur / gorge / frontal / couronne] est-il \u00e9quilibr\u00e9 ?",
    tip: "Parcourez les sept chakras un par un pour \u00e9tablir un bilan complet en quelques minutes." },
  { theme: 'spiritualite', themeLabel: '\u2728 Spiritualit\u00e9',
    text: "Cette pratique ou discipline spirituelle est-elle juste pour mon parcours en ce moment ?",
    tip: "Utile pour choisir entre m\u00e9ditation, yoga, reiki, tarot ou toute autre voie d'exploration." },
  { theme: 'spiritualite', themeLabel: '\u2728 Spiritualit\u00e9',
    text: "Y a-t-il une \u00e9nergie r\u00e9siduelle \u00e0 lib\u00e9rer dans cet espace int\u00e9rieur ?",
    tip: "Si oui, la fumigation \u00e0 la sauge blanche suivie d'une m\u00e9ditation de 10 minutes est recommand\u00e9e." },
  { theme: 'spiritualite', themeLabel: '\u2728 Spiritualit\u00e9',
    text: "Mes guides int\u00e9rieurs me transmettent-ils un message essentiel \u00e0 recevoir maintenant ?",
    tip: "Si oui, prenez un papier et un stylo, fermez les yeux et \u00e9crivez sans r\u00e9fl\u00e9chir pendant 5 minutes." }
];

// ----- RENDU DES CARTES -----
var grid = document.getElementById('questionsGrid');
var searchInput = document.getElementById('searchInput');
var filterChips = document.querySelectorAll('.chip');
var resultCount = document.getElementById('resultCount');
var noResults = document.getElementById('noResults');

var currentFilter = 'all';
var currentSearch = '';

function renderQuestions() {
  if (!grid) return;
  grid.innerHTML = '';
  var visibleCount = 0;

  QUESTIONS.forEach(function (q, idx) {
    var matchesTheme = currentFilter === 'all' || q.theme === currentFilter;
    var searchText = currentSearch.toLowerCase().trim();
    var matchesSearch = !searchText ||
      q.text.toLowerCase().indexOf(searchText) !== -1 ||
      q.themeLabel.toLowerCase().indexOf(searchText) !== -1 ||
      q.tip.toLowerCase().indexOf(searchText) !== -1;

    if (matchesTheme && matchesSearch) {
      visibleCount++;
      var card = document.createElement('div');
      card.className = 'question-card';
      card.setAttribute('data-theme', q.theme);
      card.setAttribute('data-idx', idx);
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Copier la question');
      card.innerHTML =
        '<div class="theme-symbol">' + (THEME_SVG[q.theme] || '') + '</div>'
        + '<span class="question-number">' + String(idx + 1) .replace(/^(\d)$/, '0$1') + '</span>'
        + '<span class="question-theme">' + q.themeLabel + '</span>'
        + '<p class="question-text">\u00ab ' + q.text + ' \u00bb</p>'
        + '<div class="question-tip"><strong>\u25c8 Astuce de pratique \u25c8</strong>' + q.tip + '</div>'
        + '<span class="click-hint"><span>Cliquez pour copier</span></span>';
      (function (c, i) {
        c.addEventListener('click', function () { copyQuestion(c, i); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyQuestion(c, i); }
        });
      })(card, idx);
      grid.appendChild(card);
    }
  });

  if (resultCount) {
    resultCount.textContent = visibleCount === 0
      ? 'Aucune question trouv\u00e9e'
      : (visibleCount === 1 ? '1 question r\u00e9v\u00e9l\u00e9e' : visibleCount + ' questions r\u00e9v\u00e9l\u00e9es');
  }

  if (noResults) noResults.classList.toggle('visible', visibleCount === 0);
}

// ----- FILTRES -----
Array.prototype.forEach.call(filterChips, function (chip) {
  chip.addEventListener('click', function () {
    Array.prototype.forEach.call(filterChips, function (c) { c.classList.remove('active'); });
    chip.classList.add('active');
    currentFilter = chip.getAttribute('data-theme');
    renderQuestions();
  });
});

// ----- RECHERCHE -----
var searchTimeout;
if (searchInput) {
  searchInput.addEventListener('input', function (e) {
    clearTimeout(searchTimeout);
    var val = e.target.value;
    searchTimeout = setTimeout(function () {
      currentSearch = val;
      renderQuestions();
    }, 200);
  });
}

// ----- COPIER UNE QUESTION -----
function copyQuestion(card, idx) {
  var question = QUESTIONS[idx].text;

  var doCopy = function () {
    card.classList.add('just-copied');
    showToast('\u2726 Question copi\u00e9e \u2014 elle attend votre intention');
    setTimeout(function () { card.classList.remove('just-copied'); }, 2800);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(question).then(doCopy)['catch'](function () { fallbackCopy(question, doCopy); });
  } else {
    fallbackCopy(question, doCopy);
  }
}

function fallbackCopy(text, cb) {
  var tmp = document.createElement('textarea');
  tmp.value = text;
  document.body.appendChild(tmp);
  tmp.select();
  try { document.execCommand('copy'); cb(); } catch (e) {}
  document.body.removeChild(tmp);
}

// ----- TOAST -----
var toast = document.getElementById('toast');
var toastTimeout;
function showToast(text) {
  if (!toast) return;
  clearTimeout(toastTimeout);
  toast.textContent = text || '\u2713 Question copi\u00e9e dans le presse-papier';
  toast.classList.add('show');
  toastTimeout = setTimeout(function () { toast.classList.remove('show'); }, 2800);
}

// ----- GENERATION DU PDF -----
function generatePDF() {
  var btn = document.getElementById('downloadPdfBtn');
  var btnText = document.getElementById('downloadBtnText');

  if (btn) btn.disabled = true;
  if (btnText) btnText.textContent = 'Pr\u00e9paration du grimoire...';

  try {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ format: 'a4', unit: 'mm' });

    var pageW = 210;
    var pageH = 297;
    var margin = 20;

    var GOLD = [201, 169, 110];
    var GOLD_DK = [165, 133, 74];
    var ROSE = [184, 132, 155];
    var VIOLET = [107, 76, 138];
    var INK = [59, 49, 64];
    var GREY = [106, 96, 114];
    var CREAM = [250, 247, 242];
    var WHITE = [255, 255, 255];

    function drawDiamond(x, y, size, color) {
      doc.setFillColor(color[0], color[1], color[2]);
      doc.setDrawColor(color[0], color[1], color[2]);
      doc.triangle(x, y - size, x + size, y, x, y + size, 'F');
      doc.triangle(x, y - size, x - size, y, x, y + size, 'F');
    }

    function drawOrnamentLine(y, color) {
      doc.setDrawColor(color[0], color[1], color[2]);
      doc.setLineWidth(0.3);
      doc.line(pageW / 2 - 35, y, pageW / 2 - 6, y);
      doc.line(pageW / 2 + 6, y, pageW / 2 + 35, y);
      drawDiamond(pageW / 2, y, 1.8, color);
      drawDiamond(pageW / 2 - 4, y, 0.8, color);
      drawDiamond(pageW / 2 + 4, y, 0.8, color);
    }

    function drawDot(x, y, r, color) {
      doc.setFillColor(color[0], color[1], color[2]);
      doc.circle(x, y, r, 'F');
    }

    function drawTripleDiamond(y, color) {
      drawDiamond(pageW / 2 - 6, y, 1.2, color);
      drawDiamond(pageW / 2, y, 1.8, color);
      drawDiamond(pageW / 2 + 6, y, 1.2, color);
    }

    // ===== PAGE 1 : COUVERTURE CLAIRE =====
    doc.setFillColor(CREAM[0], CREAM[1], CREAM[2]);
    doc.rect(0, 0, pageW, pageH, 'F');

    doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setLineWidth(0.6);
    doc.rect(10, 10, pageW - 20, pageH - 20);
    doc.setLineWidth(0.2);
    doc.rect(14, 14, pageW - 28, pageH - 28);

    [[16, 16], [pageW - 16, 16], [16, pageH - 16], [pageW - 16, pageH - 16]].forEach(function (p) {
      drawDot(p[0], p[1], 1.2, GOLD);
    });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
    doc.text('A S T R O Y A', pageW / 2, 36, { align: 'center' });

    doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setLineWidth(0.3);
    doc.line(pageW / 2 - 25, 40, pageW / 2 + 25, 40);
    drawDiamond(pageW / 2, 40, 1.2, GOLD);

    doc.setFont('times', 'bold');
    doc.setFontSize(38);
    doc.setTextColor(VIOLET[0], VIOLET[1], VIOLET[2]);
    doc.text('Le Grimoire', pageW / 2, 95, { align: 'center' });
    doc.text('Sacre', pageW / 2, 115, { align: 'center' });

    doc.setFont('times', 'italic');
    doc.setFontSize(18);
    doc.setTextColor(ROSE[0], ROSE[1], ROSE[2]);
    doc.text('des Sourciers', pageW / 2, 135, { align: 'center' });

    drawTripleDiamond(148, GOLD);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.setTextColor(GREY[0], GREY[1], GREY[2]);
    doc.text('30 questions puissantes a poser a votre', pageW / 2, 165, { align: 'center' });
    doc.text('baguette de radiesthesie', pageW / 2, 173, { align: 'center' });

    doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setLineWidth(0.3);
    doc.roundedRect(30, 210, pageW - 60, 58, 3, 3, 'FD');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
    doc.text('Une attention bienveillante', pageW / 2, 222, { align: 'center' });
    doc.text("de la part d'Astroya", pageW / 2, 228, { align: 'center' });

    drawDiamond(pageW / 2, 233, 1, GOLD);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.setTextColor(GREY[0], GREY[1], GREY[2]);
    var motText = [
      'Cher pratiquant, chere pratiquante,',
      '',
      'Nous vous offrons ce grimoire en temoignage de notre',
      'engagement pour une radiesthesie accessible et juste.',
      'Puisse-t-il vous accompagner sur votre chemin.'
    ];
    var y = 242;
    motText.forEach(function (line) {
      doc.text(line, pageW / 2, y, { align: 'center' });
      y += 5;
    });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
    doc.text('astroya.fr', pageW / 2, 284, { align: 'center' });

    // ===== PAGE 2 : REGLES D'OR =====
    doc.addPage();
    drawPageBase(doc, pageW, pageH, GOLD);

    doc.setFont('times', 'bold');
    doc.setFontSize(24);
    doc.setTextColor(VIOLET[0], VIOLET[1], VIOLET[2]);
    doc.text("Les 3 Regles d'Or", pageW / 2, 40, { align: 'center' });

    drawOrnamentLine(48, GOLD);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(GREY[0], GREY[1], GREY[2]);
    doc.text("Maitriser l'art de la formulation pour des reponses fiables", pageW / 2, 58, { align: 'center' });

    var rules = [
      { num: 'I', title: 'Precision Absolue',
        text: 'Chaque question doit appeler une reponse binaire claire : oui ou non, benefique ou non benefique. Evitez les formulations ouvertes ou ambigues qui troublent les signaux recus par votre baguette.' },
      { num: 'II', title: 'Intention Ancree',
        text: 'Formulez mentalement la question avant de tenir vos baguettes. Visualisez la situation. Votre clarte interieure conditionne directement la clarte de la reponse que vous recevrez.' },
      { num: 'III', title: 'Ici & Maintenant',
        text: "Ancrez la question dans l'instant present. Est-il benefique pour moi aujourd'hui de... donne des reponses beaucoup plus precises qu'une question formulee en general." }
    ];

    var ruleY = 76;
    rules.forEach(function (rule) {
      doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.setLineWidth(0.3);
      doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
      doc.roundedRect(margin, ruleY, pageW - 2 * margin, 52, 3, 3, 'FD');

      doc.setFont('times', 'bold');
      doc.setFontSize(26);
      doc.setTextColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.text(rule.num, margin + 15, ruleY + 20);

      doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
      doc.setLineWidth(0.2);
      doc.line(margin + 28, ruleY + 8, margin + 28, ruleY + 44);

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(13);
      doc.setTextColor(VIOLET[0], VIOLET[1], VIOLET[2]);
      doc.text(rule.title, margin + 34, ruleY + 14);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9.5);
      doc.setTextColor(GREY[0], GREY[1], GREY[2]);
      var lines = doc.splitTextToSize(rule.text, pageW - 2 * margin - 44);
      doc.text(lines, margin + 34, ruleY + 23);

      ruleY += 60;
    });

    addFooter(doc, pageW, pageH, GOLD, 2);

    // ===== PAGES THEMATIQUES =====
    var THEMES = [
      { key: 'amour', label: 'Amour & Relations', color: ROSE },
      { key: 'sante', label: 'Sante & Bien-etre', color: [125, 155, 138] },
      { key: 'maison', label: 'Maison & Habitat', color: GOLD_DK },
      { key: 'travail', label: 'Travail & Finances', color: VIOLET },
      { key: 'decisions', label: 'Decisions & Choix', color: [141, 108, 176] },
      { key: 'spiritualite', label: 'Spiritualite', color: GOLD_DK }
    ];

    var pageNum = 3;

    THEMES.forEach(function (theme, themeIdx) {
      doc.addPage();
      drawPageBase(doc, pageW, pageH, GOLD);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9.5);
      doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
      doc.text('Chapitre ' + (themeIdx + 1) + ' sur 6', pageW / 2, 30, { align: 'center' });

      drawDiamond(pageW / 2, 35, 1, GOLD);

      doc.setFont('times', 'bold');
      doc.setFontSize(24);
      doc.setTextColor(theme.color[0], theme.color[1], theme.color[2]);
      doc.text(theme.label, pageW / 2, 48, { align: 'center' });

      doc.setDrawColor(theme.color[0], theme.color[1], theme.color[2]);
      doc.setLineWidth(0.4);
      doc.line(pageW / 2 - 45, 54, pageW / 2 - 6, 54);
      doc.line(pageW / 2 + 6, 54, pageW / 2 + 45, 54);
      drawDiamond(pageW / 2, 54, 1.8, theme.color);

      var themeQuestions = QUESTIONS.filter(function (q) { return q.theme === theme.key; });
      var qY = 68;

      themeQuestions.forEach(function (q) {
        var globalIdx = QUESTIONS.findIndex(function (qq) { return qq.text === q.text; }) + 1;

        doc.setFont('times', 'italic');
        doc.setFontSize(11.5);
        var qLines = doc.splitTextToSize('" ' + q.text + ' "', pageW - 2 * margin - 18);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.5);
        var tipLines = doc.splitTextToSize(q.tip, pageW - 2 * margin - 18);

        var cardHeight = 14 + (qLines.length * 5) + 10 + (tipLines.length * 4) + 6;

        doc.setDrawColor(228, 220, 208);
        doc.setLineWidth(0.2);
        doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
        doc.roundedRect(margin, qY, pageW - 2 * margin, cardHeight, 2, 2, 'FD');

        doc.setDrawColor(theme.color[0], theme.color[1], theme.color[2]);
        doc.setLineWidth(1.5);
        doc.line(margin + 2, qY + 4, margin + 2, qY + cardHeight - 4);

        doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
        doc.circle(margin + 10, qY + 8, 4, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(255, 255, 255);
        doc.text(String(globalIdx).replace(/^(\d)$/, '0$1'), margin + 10, qY + 9.5, { align: 'center' });

        doc.setFont('times', 'italic');
        doc.setFontSize(11.5);
        doc.setTextColor(INK[0], INK[1], INK[2]);
        doc.text(qLines, margin + 18, qY + 10);

        var astuceY = qY + 10 + (qLines.length * 5) + 5;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7);
        doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
        doc.text('ASTUCE DE PRATIQUE', margin + 18, astuceY);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.5);
        doc.setTextColor(GREY[0], GREY[1], GREY[2]);
        doc.text(tipLines, margin + 18, astuceY + 4);

        qY += cardHeight + 4;
      });

      addFooter(doc, pageW, pageH, GOLD, pageNum);
      pageNum++;
    });

    // ===== PAGE FINALE =====
    doc.addPage();
    drawPageBase(doc, pageW, pageH, GOLD);

    doc.setFont('times', 'bold');
    doc.setFontSize(24);
    doc.setTextColor(VIOLET[0], VIOLET[1], VIOLET[2]);
    doc.text('Votre Chemin Continue', pageW / 2, 60, { align: 'center' });

    drawOrnamentLine(68, GOLD);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(GREY[0], GREY[1], GREY[2]);
    doc.text('Quelques derniers mots avant de vous quitter...', pageW / 2, 78, { align: 'center' });

    doc.setFillColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
    doc.setLineWidth(0.3);
    doc.roundedRect(margin, 92, pageW - 2 * margin, 100, 3, 3, 'FD');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(GREY[0], GREY[1], GREY[2]);

    var finalText = [
      "La radiesthesie est un art vivant qui s'affine avec la pratique",
      "et l'humilite. Les questions de ce grimoire ne sont que des points",
      "de depart : laissez votre intuition les adapter a votre situation,",
      'votre vocabulaire, votre coeur.',
      '',
      'Tenez un carnet de session. Notez vos questions, les reponses',
      'recues, et ce qui se passe ensuite dans votre vie.',
      'Vous y verrez des patterns precieux.',
      '',
      'Chez Astroya, nous selectionnons chaque baguette, chaque pierre,',
      'chaque encens avec soin, pour accompagner votre cheminement.'
    ];

    var fY = 104;
    finalText.forEach(function (line) {
      doc.text(line, pageW / 2, fY, { align: 'center' });
      fY += 6;
    });

    doc.setFont('times', 'italic');
    doc.setFontSize(12);
    doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
    doc.text("- L'equipe Astroya", pageW / 2, 208, { align: 'center' });

    drawTripleDiamond(222, GOLD);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(VIOLET[0], VIOLET[1], VIOLET[2]);
    doc.text('Decouvrez nos baguettes de radiesthesie', pageW / 2, 234, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(ROSE[0], ROSE[1], ROSE[2]);
    doc.text('astroya.fr/collections/baguettes-de-radiesthesie', pageW / 2, 244, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(GOLD_DK[0], GOLD_DK[1], GOLD_DK[2]);
    doc.text('Livraison offerte des 69 euros', pageW / 2, 258, { align: 'center' });

    drawTripleDiamond(272, GOLD);

    addFooter(doc, pageW, pageH, GOLD, pageNum);

    // ===== LIVRAISON =====
    var blob = doc.output('blob');
    var url = URL.createObjectURL(blob);

    window.open(url, '_blank');

    var a = document.createElement('a');
    a.href = url;
    a.download = 'Grimoire-Sourciers-Astroya.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);

    if (btn) btn.disabled = false;
    if (btnText) btnText.textContent = '\u2713 Votre grimoire est \u00e0 vous';
    showToast('\u2726 Votre grimoire vous accompagne');
    setTimeout(function () {
      if (btnText) btnText.textContent = 'Recevoir le Grimoire Offert';
    }, 3500);

  } catch (err) {
    if (btn) btn.disabled = false;
    if (btnText) btnText.textContent = 'Recevoir le Grimoire Offert';
    alert("Une erreur est survenue lors de la g\u00e9n\u00e9ration. Rafra\u00eechissez la page et r\u00e9essayez.");
  }
}

// Fond de page clair + bordure doree
function drawPageBase(doc, pageW, pageH, GOLD) {
  doc.setFillColor(250, 247, 242);
  doc.rect(0, 0, pageW, pageH, 'F');
  doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
  doc.setLineWidth(0.5);
  doc.rect(10, 10, pageW - 20, pageH - 20);
  doc.setLineWidth(0.15);
  doc.rect(13, 13, pageW - 26, pageH - 26);

  doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
  [[16, 16], [pageW - 16, 16], [16, pageH - 16], [pageW - 16, pageH - 16]].forEach(function (p) {
    var cx = p[0], cy = p[1];
    doc.triangle(cx, cy - 1.3, cx + 1.3, cy, cx, cy + 1.3, 'F');
    doc.triangle(cx, cy - 1.3, cx - 1.3, cy, cx, cy + 1.3, 'F');
  });
}

// Footer
function addFooter(doc, pageW, pageH, GOLD, num) {
  doc.setDrawColor(GOLD[0], GOLD[1], GOLD[2]);
  doc.setLineWidth(0.2);
  doc.line(pageW / 2 - 22, pageH - 20, pageW / 2 - 3, pageH - 20);
  doc.line(pageW / 2 + 3, pageH - 20, pageW / 2 + 22, pageH - 20);

  doc.setFillColor(GOLD[0], GOLD[1], GOLD[2]);
  doc.triangle(pageW / 2, pageH - 21, pageW / 2 + 1.2, pageH - 20, pageW / 2, pageH - 19, 'F');
  doc.triangle(pageW / 2, pageH - 21, pageW / 2 - 1.2, pageH - 20, pageW / 2, pageH - 19, 'F');

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(165, 133, 74);
  doc.text('- ' + num + ' -', pageW / 2, pageH - 14, { align: 'center' });

  doc.setFontSize(8);
  doc.setTextColor(150, 142, 158);
  doc.text('Grimoire Sacre des Sourciers  -  astroya.fr', pageW / 2, pageH - 8, { align: 'center' });
}
window.generatePDF = generatePDF;

// ----- FAQ DESKTOP -----
Array.prototype.forEach.call(document.querySelectorAll('.faq-question'), function (q) {
  q.addEventListener('click', function () { q.parentElement.classList.toggle('open'); });
});

// Rendu initial
renderQuestions();


/* ==========================================
   VERSION MOBILE
   ========================================== */
(function () {
  if (window.innerWidth >= 900) return;

  // ----- POUSSIERE DOREE MOBILE -----
  (function gmStarfield() {
    var canvas = document.getElementById('gm-stars');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var stars = [];

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      stars = [];
      var count = Math.floor((canvas.width * canvas.height) / 22000);
      for (var i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.3 + 0.4,
          opacity: Math.random() * 0.40 + 0.15,
          speed: Math.random() * 0.12 + 0.02,
          twinkle: Math.random() * Math.PI * 2,
          gold: Math.random() > 0.4
        });
      }
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(function (s) {
        s.twinkle += 0.015;
        var op = s.opacity * (0.5 + 0.5 * Math.sin(s.twinkle));
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.gold
          ? 'rgba(201, 169, 110, ' + op + ')'
          : 'rgba(184, 132, 155, ' + op + ')';
        ctx.fill();
        s.y += s.speed;
        if (s.y > canvas.height) { s.y = 0; s.x = Math.random() * canvas.width; }
      });
      requestAnimationFrame(animate);
    }

    resize();
    window.addEventListener('resize', resize);
    animate();
  })();

  var GM_SVG = {
    amour: '<svg viewBox="0 0 48 48" fill="none" stroke="#b8849b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M24 40 C 12 30, 5 22, 5 15 C 5 10, 9 6, 14 6 C 18 6, 22 9, 24 13 C 26 9, 30 6, 34 6 C 39 6, 43 10, 43 15 C 43 22, 36 30, 24 40 Z"/><circle cx="24" cy="15" r="1.5" fill="#b8849b"/></svg>',
    sante: '<svg viewBox="0 0 48 48" fill="none" stroke="#7d9b8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M24 6 Q 36 10, 38 22 Q 40 34, 24 42 Q 8 34, 10 22 Q 12 10, 24 6 Z"/><path d="M24 10 L24 38" opacity="0.7"/><path d="M24 16 Q 18 18, 16 24 M24 16 Q 30 18, 32 24" opacity="0.7"/></svg>',
    maison: '<svg viewBox="0 0 48 48" fill="none" stroke="#c9a96e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 24 L24 8 L42 24"/><path d="M10 22 L10 42 L38 42 L38 22"/><path d="M20 42 L20 30 L28 30 L28 42"/><circle cx="24" cy="18" r="1.5" fill="#c9a96e"/></svg>',
    travail: '<svg viewBox="0 0 48 48" fill="none" stroke="#6b4c8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M24 4 L44 24 L24 44 L4 24 Z"/><path d="M24 12 L36 24 L24 36 L12 24 Z"/><circle cx="24" cy="24" r="2.5" fill="#6b4c8a"/></svg>',
    decisions: '<svg viewBox="0 0 48 48" fill="none" stroke="#c9a96e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="19"/><circle cx="24" cy="24" r="14" opacity="0.5"/><path d="M24 8 L27 24 L24 27 L21 24 Z" fill="#c9a96e"/><circle cx="24" cy="24" r="2" fill="#c9a96e"/></svg>',
    spiritualite: '<svg viewBox="0 0 48 48" fill="none" stroke="#6b4c8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M24 4 L28 18 L42 20 L32 30 L34 44 L24 36 L14 44 L16 30 L6 20 L20 18 Z"/><circle cx="24" cy="24" r="3"/><circle cx="24" cy="24" r="1" fill="#6b4c8a"/></svg>'
  };

  var GM_META = {
    amour: { emoji: '\uD83D\uDC96', name: 'Amour & Relations', intro: "Cinq questions pour explorer la justesse de vos liens affectifs, clarifier vos ressentis et affiner votre intuition relationnelle." },
    sante: { emoji: '\uD83C\uDF3F', name: 'Sant\u00e9 & Bien-\u00eatre', intro: "Cinq questions pour \u00e9couter les besoins subtils de votre corps, ajuster votre \u00e9nergie et choisir les soins les plus align\u00e9s." },
    maison: { emoji: '\uD83C\uDFE0', name: 'Maison & Habitat', intro: "Cinq questions pour harmoniser votre lieu de vie, d\u00e9tecter les perturbations g\u00e9obiologiques et cr\u00e9er un foyer ressour\u00e7ant." },
    travail: { emoji: '\uD83D\uDCBC', name: 'Travail & Finances', intro: "Cinq questions pour \u00e9clairer vos choix professionnels, \u00e9valuer les opportunit\u00e9s et lib\u00e9rer les blocages d'abondance." },
    decisions: { emoji: '\uD83E\uDDED', name: 'D\u00e9cisions & Choix', intro: "Cinq questions pour trancher les dilemmes, v\u00e9rifier la fiabilit\u00e9 de votre intuition et poser des choix align\u00e9s." },
    spiritualite: { emoji: '\u2728', name: 'Spiritualit\u00e9', intro: "Cinq questions pour explorer votre chemin int\u00e9rieur, \u00e9quilibrer vos chakras et dialoguer avec vos guides." }
  };

  var GM_ORDER = ['amour', 'sante', 'maison', 'travail', 'decisions', 'spiritualite'];

  var themesContainer = document.getElementById('gmThemes');
  if (!themesContainer) return;
  themesContainer.innerHTML = '';

  var counter = 0;

  GM_ORDER.forEach(function (id) {
    var meta = GM_META[id];
    var qs = QUESTIONS.filter(function (q) { return q.theme === id; });

    var themeEl = document.createElement('div');
    themeEl.className = 'gm-theme';
    themeEl.id = 'gm-theme-' + id;

    var questionsHtml = '';
    qs.forEach(function (q) {
      counter++;
      var num = String(counter).replace(/^(\d)$/, '0$1');
      questionsHtml +=
        '<div class="gm-q" data-text="' + q.text.replace(/"/g, '&quot;') + '">'
        + '<div class="gm-q-head">'
        + '<span class="gm-q-num">' + num + '</span>'
        + '<p class="gm-q-text">\u00ab ' + q.text + ' \u00bb</p>'
        + '<span class="gm-q-arrow">\u25b8</span>'
        + '</div>'
        + '<div class="gm-q-body"><div class="gm-q-tip">'
        + '<span class="gm-q-tip-label">\u25c8 Astuce de pratique \u25c8</span>'
        + q.tip + '</div></div></div>';
    });

    themeEl.innerHTML =
      '<div class="gm-theme-head">'
      + '<div class="gm-theme-icon">' + GM_SVG[id] + '</div>'
      + '<div class="gm-theme-info">'
      + '<div class="gm-theme-name">' + meta.emoji + ' ' + meta.name + '</div>'
      + '<div class="gm-theme-meta">' + qs.length + ' questions sacr\u00e9es</div>'
      + '</div>'
      + '<span class="gm-theme-chev">\u25be</span>'
      + '</div>'
      + '<div class="gm-theme-body">'
      + '<p class="gm-theme-intro">' + meta.intro + '</p>'
      + '<div class="gm-qlist">' + questionsHtml + '</div>'
      + '</div>';

    themesContainer.appendChild(themeEl);
  });

  // Delegation au niveau document (survit aux re-renders EComposer)
  document.addEventListener('click', function (e) {
    var head = e.target.closest ? e.target.closest('.gm-theme-head') : null;
    if (head) { head.parentElement.classList.toggle('open'); return; }

    var qHead = e.target.closest ? e.target.closest('.gm-q-head') : null;
    if (qHead) { qHead.parentElement.classList.toggle('open'); return; }

    var faq = e.target.closest ? e.target.closest('.gm-faq-q') : null;
    if (faq) { faq.parentElement.classList.toggle('open'); return; }

    var pill = e.target.closest ? e.target.closest('.gm-pill') : null;
    if (pill) {
      var target = pill.getAttribute('data-jump');
      Array.prototype.forEach.call(document.querySelectorAll('.gm-pill'), function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
      var themeEl2 = document.getElementById('gm-theme-' + target);
      if (themeEl2) {
        themeEl2.classList.add('open');
        setTimeout(function () {
          themeEl2.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 80);
      }
    }
  });

  // TOAST MOBILE
  var toastEl = document.getElementById('gmToast');
  var toastTimer;
  window.gmToast = function (msg) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.textContent = msg || '\u2713 Question copi\u00e9e';
    toastEl.classList.add('show');
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2800);
  };

  // PDF MOBILE
  window.gmGeneratePDF = function () {
    var btn = document.getElementById('gmPdfBtn');
    var txt = document.getElementById('gmPdfTxt');

    if (typeof window.generatePDF === 'function') {
      if (btn) btn.disabled = true;
      if (txt) txt.textContent = 'Pr\u00e9paration du grimoire...';
      setTimeout(function () {
        try {
          window.generatePDF();
          setTimeout(function () {
            if (btn) btn.disabled = false;
            if (txt) txt.textContent = '\u2726 Grimoire t\u00e9l\u00e9charg\u00e9 \u2014 Merci !';
            window.gmToast('\uD83D\uDCDC Le Grimoire est dans vos t\u00e9l\u00e9chargements');
            setTimeout(function () { if (txt) txt.textContent = 'Recevoir le Grimoire Offert'; }, 3500);
          }, 1500);
        } catch (e) {
          if (btn) btn.disabled = false;
          if (txt) txt.textContent = 'Recevoir le Grimoire Offert';
          window.gmToast('Une erreur est survenue, r\u00e9essayez');
        }
      }, 50);
    } else {
      window.gmToast('Le PDF arrive \u2014 patientez quelques secondes');
      if (btn) btn.disabled = true;
      if (txt) txt.textContent = 'Chargement...';
      setTimeout(function () {
        if (btn) btn.disabled = false;
        if (txt) txt.textContent = 'Recevoir le Grimoire Offert';
        window.gmToast('Rechargez la page puis r\u00e9essayez');
      }, 1500);
    }
  };
})();
} catch(error){console.error(error);}